import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';
import { PlatformReviewModal } from './PlatformReviewModal';

const linkStyle = { color: 'rgba(255,255,255,0.85)', background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.875rem', padding: 0, textDecoration: 'none' };

export const CatalogFooter = ({ isNarrow, onLogin, primaryColor }) => {
  const [showReview, setShowReview] = useState(false);
  return (
    <footer style={{ background: '#1a2332' }} data-testid="catalog-footer">
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: isNarrow ? '1.25rem 1rem' : '1.5rem 2rem', display: 'flex', alignItems: 'center',
        justifyContent: isNarrow ? 'center' : 'space-between', flexDirection: isNarrow ? 'column' : 'row', gap: '1rem', flexWrap: 'wrap' }}>
        <a href="/" style={{ display: 'inline-flex' }} data-testid="catalog-footer-logo-link">
          <img src="/livrum-logo-light.webp" alt="Livrum" data-testid="catalog-footer-logo"
            style={{ height: '26px', width: 'auto', filter: 'brightness(0) invert(1)' }} />
        </a>
        <nav style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.75rem', color: 'rgba(255,255,255,0.4)', flexWrap: 'wrap' }}>
          <button type="button" onClick={() => setShowReview(true)} style={linkStyle} data-testid="footer-review-link">Avalie a plataforma Livrum</button>
          <span>|</span>
          <Link to="/termos-de-uso" style={linkStyle} data-testid="footer-terms-link">Termos de uso</Link>
          <span>|</span>
          <a href="https://www.instagram.com/livrum.com.br/" target="_blank" rel="noopener noreferrer" aria-label="Instagram @livrum.com.br"
            data-testid="footer-instagram-link" style={{ ...linkStyle, display: 'inline-flex' }}>
            <Instagram className="w-5 h-5" style={{ color: 'white' }} />
          </a>
        </nav>
      </div>
      {showReview && <PlatformReviewModal onClose={() => setShowReview(false)} onLogin={onLogin} primaryColor={primaryColor} />}
    </footer>
  );
};
